import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import style from './SupportedBrands.module.css';
import { useTranslation } from 'react-i18next';
import { sponsors } from '../../utils';
import { Footer } from '../../components';

const SupportedBrands = () => {
  const {t} = useTranslation();
  return (
    <Container className="p-0" fluid>
      <Row className={`m-0 py-4 py-md-5 justify-content-center ${style.header}`}>
        <Col xs={11} md={7} lg={6} className='align-content-center'>
          <h1 className={`mb-md-4 ${style.headerTitle}`}>
            {t("Supported Brands")}
          </h1>
        </Col>
      </Row>
      <Row className='justify-content-center my-4 mx-0'>
        <Col xs={11} md={7} lg={6} xl={8} className='mt-4'>
          <p className={style.txt}>{t("supportedBrandsTxt1")}</p>
        </Col>
      </Row>
      <Row className='p-4 mx-0'>
        {
          sponsors.map((sponsor, index)=>(
            <Col lg={3} className='d-flex justify-content-center my-2'>
              <div className={`text-center align-content-center ${style.imgContainer}`}>
                <Image src={sponsor.image} className={style.sponsorImg} />
              </div>
            </Col>
          )
        )}
      </Row>
      <Row className='justify-content-center my-4 mx-0'>
        <Col xs={11} md={7} lg={6} xl={8} className='mt-4'>
          <p className={style.txt}>{t("supportedBrandsTxt2")}</p>
        </Col>
      </Row>
      <Footer />
    </Container>
  )
}

export default SupportedBrands;